import { createBrowserRouter, useNavigate, Navigate } from 'react-router-dom';
import { NavigationComponent } from '../controls';
import { EditorPage, PackSettingsPage, MilestonesPage, ClientSettingsPage, PlayerStatisticsPage } from '../pages';
import MapsPage from '../pages/maps';
import PackPage from '../pages/pack';
import { MenuItem } from 'primereact/menuitem';

export const Router = createBrowserRouter([
  {
    path: '/',
    element: <NavigationComponent />,
    children: [
      {
        index: true,
        element: <Navigate to="/packs" replace />,
      },
      {
        path: '/maps/new',
        element: <EditorPage />,
      },
      {
        path: '/maps/:id',
        element: <EditorPage />,
      },
      {
        path: '/pack-settings',
        element: <PackSettingsPage />,
      },
      {
        path: '/packs',
        element: <PackPage />,
      },
      {
        path: '/maps',
        element: <MapsPage />,
      },
      {
        path: '/milestones',
        element: <MilestonesPage />,
      },
      {
        path: '/client-settings',
        element: <ClientSettingsPage />,
      },
      {
        path: '/player-statistics',
        element: <PlayerStatisticsPage />,
      },
    ],
  },
]);

const useMenu = () => {
  const navigate = useNavigate();

  const menu = [
    {
      label: `Packages`,
      icon: 'pi pi-box',
      command: () => {
        navigate('/packs');
      },
    },
    {
      label: `Settings`,
      icon: 'pi pi-cog',
      command: () => {
        navigate('/pack-settings');
      },
    },
    {
      label: `Maps`,
      icon: 'pi pi-map',
      command: () => {
        navigate('/maps');
      },
    },
    {
      label: `Milestones`,
      icon: 'pi pi-flag',
      command: () => {
        navigate('/milestones');
      },
    },
    {
      label: `Client Settings`,
      icon: 'pi pi-cog',
      command: () => {
        navigate('/client-settings');
      },
    },
    {
      label: `Player statistics`,
      icon: 'pi pi-users',
      command: () => {
        navigate('/player-statistics');
      },
    },
  ] as MenuItem[];

  return {
    menu,
    navigate,
    goToLevelEdit: (id: number) => {
      navigate(`/maps/${id}`);
    },
    goToMaps: (levelNumber?: number) => {
      if (levelNumber) {
        navigate({ pathname: '/maps', hash: `#level-${levelNumber}` });
      } else {
        navigate('/maps');
      }
    },
  };
};

export default useMenu;
